import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IContextService, IContextServiceToken } from './context-service.interface';

@Injectable({
  providedIn: 'root'
})
export class ContextService implements IContextService {
  private contextSource: BehaviorSubject<string>;
  private uiRefresh: BehaviorSubject<void>;

  public constructor() {
    this.contextSource = new BehaviorSubject<string>('');
    this.uiRefresh = new BehaviorSubject<void>(undefined);
  }

  public contextGet(): string {
    return this.contextSource.value;
  }

  public contextChangeGet(): Observable<string> {
    return this.contextSource.asObservable();
  }

  public contextSetDefault(): void {
    this.contextSet('');
  }

  public contextSet(context: string): void {
    if (context.localeCompare(this.contextSource.value) == 0) {
      return;
    }

    this.contextSource.next(context);
  }

  public contextTriggerUiRefresh(): void {
    this.uiRefresh.next();
  }

  public contextUiRefreshChangedGet(): Observable<void> {
    return this.uiRefresh.asObservable();
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContextServiceProvider: Provider[] = [
  { provide: IContextServiceToken, useExisting: ContextService }
];
